import { writable } from "svelte/store";
import { isRoomSpatialVendor } from "../WebRtc/spatial-audio-core";

const ROOM_SPATIAL_AUDIO_SPACE_MARKER = "#dystopia-room-spatial#";

export const roomSpatialAudioActiveStore = writable(false);

export function isRoomSpatialAudioSpaceName(spaceName: string): boolean {
    return spaceName.includes(ROOM_SPATIAL_AUDIO_SPACE_MARKER);
}

/**
 * Seed room-spatial mode from the map, before any connection exists.
 *
 * The space-name signal below only arrives on `joinSpaceRequestMessage`, which
 * can lose the race against the first `GroupCreatedUpdatedEvent`. A conversation
 * bubble built in that window survives until the next group message - that is,
 * until somebody moves - because the suppression in GameScene is only evaluated
 * when a group message is drained. The WAM is loaded in `GameScene.preload()`,
 * long before either message, and carries the same authority the back reads.
 *
 * The space-name signal stays authoritative once it arrives: if the server
 * disagrees with the map, its answer wins one round trip later.
 */
export function setRoomSpatialAudioActiveFromWam(wamFile: unknown): void {
    const vendor = (wamFile as { vendor?: unknown } | undefined)?.vendor;
    roomSpatialAudioActiveStore.set(isRoomSpatialVendor(vendor));
}

export function setRoomSpatialAudioActiveFromSpace(spaceName: string): void {
    roomSpatialAudioActiveStore.set(isRoomSpatialAudioSpaceName(spaceName));
}

export function clearRoomSpatialAudioActiveFromSpace(spaceName: string): void {
    if (isRoomSpatialAudioSpaceName(spaceName)) {
        roomSpatialAudioActiveStore.set(false);
    }
}

export function resetRoomSpatialAudioActive(): void {
    roomSpatialAudioActiveStore.set(false);
}
